export const SEARCH_CATEGORIES = {
  all: {
    name: 'All',
    active: true,
    resultsURL: '/search-results?q=',
  },
  documentation: {
    name: 'Documentation',
    pluralName: 'Documentations',
    resultsURL: '/docs/search?q=',
  },
  diagrams: {
    name: 'Diagrams',
    resultsURL: '/community/see-all?filter=diagrams&q=',
  },
  designers: {
    name: 'Designers',
    resultsURL: '/community/see-all?filter=designers&q=',
  },
}
